export const BULK_FILTERS_KEY = {
  all: 'all',
  phones: 'phones',
  workEmails: 'workEmails',
  directEmails: 'directEmails',
  wishlist: 'wishlist',
  wishlistNoData: 'wishlistNoData',
};

export const DEFAULT_BULK_FILTERS = [
  {
    title: 'Phones',
    key: 'phones',
  },
  {
    title: 'Work emails',
    key: 'workEmails',
  },
  {
    title: 'Direct emails',
    key: 'directEmails',
  },
  {
    title: 'Manually added',
    key: BULK_FILTERS_KEY.wishlist,
  },
  {
    title: 'Missing info',
    key: BULK_FILTERS_KEY.wishlistNoData,
  },
];

export const BULK_NOT_ENOUGH_TOAST = {
  id: 'bulk-not-enough-credits-toast',
  firstButtonName: 'Upgrade Plan',
  secondButtonName: 'Refresh',
  firstBtnVariant: 'text',
  secondBtnVariant: 'primary',
  className: 'bulk-not-enough-credits-notification',
  userClassName: 'bulk-not-enough-credits-notification user-notification',
  type: 'BlueFail',
};

export const BULK_PLUGIN_VERSION = '10.1.99';

export const ALL_OPTIONS_FILTER = 'all';

export const BULK_EMPTY_STATES_TYPES = {
  oldPageWithoutContacts: 'oldPageWithoutContacts',
  newPageWithoutContacts: 'newPageWithoutContacts',
  serverError: 'serverError',
  noContactsToEnrich: 'noContactsToEnrich',
};
